import { render, staticRenderFns } from "./CourierServices.vue?vue&type=template&id=930e7424"
import script from "./CourierServices.vue?vue&type=script&lang=js"
export * from "./CourierServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports